///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbDateInputBaseComponent } from './../date-input.base.component';
import { TimePickerComponent } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'kb-time-picker',
    templateUrl: './time-picker.component.html',
})
export class KbTimePickerComponent extends KbDateInputBaseComponent {
    @ViewChild(TimePickerComponent)
    public timePicker: TimePickerComponent;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/time-picker/time-picker.component.ts